import bn from 'bignumber.js';
import * as r from 'ramda';
import { noop } from './util';

export default ({ optionality, prices, log, optionContract, serviceFactory, config, cache }) => cache((pair, expiration) => {
  const priceCount = config.priceCount || 15;

  var strikeMap = {};
  var start = 0;
  var unsubs = [];
  return serviceFactory({
    name: 'strikes-service',
    subscribe: (update) => {

      const sendUpdate = (refreshing) => {
        update({ strikes: Object.values(strikeMap).sort((x, y) => x.price.comparedTo(y.price)) }, refreshing);
      };

      const createAndUnderwrite = async (type, price, amount, sellorder = '') => {
        const opty = await optionality.deployed();
        const isPut = type === 'put';
        const required = bn(amount || 0).times(bn(10).pow(+pair.decimals));
        const numerator = bn(price || 0).times(bn(10).pow(+pair.currency.decimals));
        const denominator = bn(10).pow(+pair.target.decimals);
        opty.createOptionAndUnderwrite(isPut, pair.target.address, numerator.toString(), denominator.toString(), pair.currency.address, Math.floor(+expiration / 1000), required.toString(), sellorder);
      }

      unsubs.push(prices(pair).subscribe(info => {
        if (!info._refreshing) {
          var newStart = bn(info.price || 0).idiv(info.bucket || 1).times(info.bucket).minus(bn(Math.floor(priceCount / 2) - 1).times(info.bucket));
          if (!newStart.isEqualTo(start)) {
            start = newStart;
            var existing = r.pickBy(strike => strike.call || strike.put, strikeMap)
            var virtual = {};
            r.times(n => {
              var price = start.plus(bn(info.bucket || 0).times(n));
              virtual[price.toString()] = {
                pair,
                expiration,
                price,
                put: {
                  underwrite: (amount, sellorder) => createAndUnderwrite('put', price, amount, sellorder)
                },
                call: {
                  underwrite: (amount, sellorder) => createAndUnderwrite('call', price, amount, sellorder)
                },
                label: () => {
                  return pair.name + " @ " + price.toString() + " before " + expiration.toISODate()
                }
              };
            }, priceCount)
            strikeMap = Object.assign(existing, virtual);
            sendUpdate();
          }
        } else {
          start = 0;
          sendUpdate(true);
        }
      }))
      log.handle('strikes-service setup', async () => {
        const opty = await optionality.deployed()
        const watcher = opty.OptionCreated({
            target: pair.target.address,
            currency: pair.currency.address,
            expiration: Math.floor(+expiration / 1000)
          }, {
            fromBlock: 0,
            toBlock: 'latest'
          })
          .watch((err, event) => {
            if (err) {
              log.error(err);
            } else {
              log.handle('updating strikemap', async () => {
                const option = await optionContract.at(event.args.option);
                const priceString = await option.priceString();
                if (!strikeMap[priceString]) {
                  var price = bn(priceString || 0);
                  strikeMap[priceString] = {
                    pair,
                    expiration,
                    price,
                    put: {
                      underwrite: (amount, sellOrder) => createAndUnderwrite('put', price, amount, sellOrder)
                    },
                    call: {
                      underwrite: (amount, sellOrder) => createAndUnderwrite('call', price, amount, sellOrder)
                    },
                    label: () => {
                      return pair.name + " @ " + price.toString() + " before " + expiration.toISODate()
                    }
                  };
                }
                strikeMap[priceString][event.args.put ? 'put' : 'call'] = {
                  address: event.args.option,
                  underwrite: async (amount, sellOrder = '') => {
                    const required = bn(amount || 0).times(bn(10).pow(+pair.decimals));
                    return optionContract.at(event.args.option).then(option => option.underwriteAndSell(required.toString(), sellOrder))
                  }
                }
                sendUpdate();
              })
            }
          })
        unsubs.push(() => watcher.stopWatching(noop));
      });

      return () => {
        unsubs.forEach(fn => fn());
      }
    }
  })
});


// WEBPACK FOOTER //
// ./src/api/strikes-service.js